@for (item of mobileFormData(); track item) {
  <div class="my-3">
    <div class="fw-bold">
      {{ item?.prompt_data?.name ? item?.prompt_data?.name : "Mobile Form" }}
    </div>
    @for (dataItem of item?.data; track dataItem) {
      <div>
        <ng-template
          *ngTemplateOutlet="promptDetailTemplate; context: { value: dataItem }"
        ></ng-template>
      </div>
    }
  </div>
}

<!--looped prompt template-->
<ng-template let-dataItem="value" #promptDetailTemplate>
  @if (dataItem?.description) {
    <div>
      <dl>
        <dt class="text-uppercase">{{ dataItem?.description }}</dt>
        <dd>{{ dataItem | misc: "promptValue" }}</dd>
      </dl>
    </div>
  }

  @if (dataItem?.file_id && promptFileDataUrls?.[dataItem?.file_id]?.file_url) {
    <img
      (click)="onOpenFile(promptFileDataUrls?.[dataItem?.file_id])"
      src="{{ promptFileDataUrls?.[dataItem?.file_id]?.file_url }}"
      height="120"
      width="120"
      class="small-img-preview"
    />
  }
  @for (option of dataItem?.options; track option) {
    <div>
      <ng-template
        *ngTemplateOutlet="promptDetailTemplate; context: { value: option }"
      ></ng-template>
    </div>
  }
</ng-template>
